import {toast} from "react-toastify";

// Constantes pour les mappages de codes d'erreur
const STATUS_CODE_MAPPING = {
    415: 'Type de fichier non supporté',
    413: 'Fichier trop lourd',
    429: `Trop d'actions dans un court laps de temps, veuillez patienter avant de recommencer.`,
    500: 'Une erreur serveur est survenue, contactez un administrateur ou un membre de l\'équipe technique',
    501: 'Cette fonctionnalité n\'est pas disponible',
    ERR_NETWORK: 'Nous rencontrons quelques difficultés merci de recommencer d\'ici quelques minutes '
};

// Variable pour contrôler l'affichage des toasts
let isToggleToast = true;

/**
 * Normalise la structure d'une erreur
 * @param {Object} params - Paramètres d'erreur
 * @returns {Object} - Erreur normalisée
 */
function normalizeError({
    errors = {},
    message = null,
    name = null,
    statusCode = null,
    error = null,
    config = null
}) {
    return {
        errors,
        message,
        name,
        statusCode,
        error,
        config
    };
}

/**
 * Normalise les erreurs de l'API
 * @param {Error} error - L'erreur à normaliser
 * @returns {Object} - L'erreur avec une structure normalisée
 */
function errorNormalizer(error) {
    // Extraction des données d'erreur
    const errorResponse = error.response || {};
    const responseData = errorResponse.data || {};
    
    // Construction de l'erreur normalisée
    let normalized = normalizeError({
        errors: responseData.errors,
        message: responseData.message || errorResponse.statusText,
        name: null,
        statusCode: responseData.statusCode || errorResponse.status,
        error: responseData.error || errorResponse.statusText,
        config: error.config,
    });
    
    // Gestion des erreurs réseau spécifiques
    if (!errorResponse.status) {
        if (error.code === "ERR_NETWORK" || error.code === "ECONNABORTED") {
            normalized = error
        }
    }

    // Affichage du toast d'erreur si nécessaire
    if (STATUS_CODE_MAPPING[normalized.statusCode] && isToggleToast) {
        isToggleToast = false;
        toast(STATUS_CODE_MAPPING[normalized.statusCode], {
            autoClose: 10000,
            className: 'toast-background toast-error',
            bodyClassName: "toast-font toast-error",
            progressClassName: 'toast-loader toast-error'
        });
    }

    return {...error, response: normalized};
}

/**
 * Processeur de réponse réussie
 * @param {Object} res - La réponse de l'API
 * @returns {Object} - Les données de la réponse
 */
export function response(res) {
    return res.data;
}

/**
 * Gestionnaire d'erreur pour les requêtes standard
 * @param {Error} error - L'erreur reçue
 * @returns {Promise} - Promesse rejetée avec l'erreur normalisée
 */
export function responseError(error) {
    const normalizedError = errorNormalizer(error);
    return Promise.reject(normalizedError);
}

/**
 * Gestionnaire d'erreur pour les requêtes de type Query
 * @param {Error} error - L'erreur reçue
 * @returns {Promise} - Promesse rejetée avec la réponse normalisée de l'erreur
 */
export function responseQueryError(error) {
    const normalizedError = errorNormalizer(error);
    return Promise.reject(normalizedError.response);
}

// Exportation de l'intercepteur
const dataInterceptor = {
    response,
    responseError,
    responseQueryError
};

export default dataInterceptor;